import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Icon from 'antd/lib/icon';
import Table from 'antd/lib/table';
import draftToHtml from 'draftjs-to-html';
import { Checkbox } from 'antd';
import { ResponsiveTable } from '../../../../common/components/data-display';
import { formatDateTime } from '../../../../common/utils/helpers';
import { t } from '../../../../app/i18n';

const Column = Table.Column;

const QuestionList = ({ questions, isLoadingQ}) => {
  // const options = [
  //   { label: t('Interná komunikácia'), value: 'internal' },
  //   { label: t('Externá komunikácia'), value: 'external' },
  // ];

  return (
    <section className="documents-wrapper message-table">
      
      <ResponsiveTable dataSource={questions} rowKey={question => question.id} loading={isLoadingQ}>
        <Column
          dataIndex="question"
          key="question"
          title={t('Otázka')}
          render={question => question}
        />
        <Column
          dataIndex="answer"
          key="answer"
          title={t('Odpoveď')}
          render={answer => answer}
        />
        <Column
          dataIndex="date_question"
          key="date_question"
          title={t('Dátum otázky')}
          render={date_question => formatDateTime(date_question)}
        />
      </ResponsiveTable>
    </section>
  );
};

QuestionList.propTypes = {
  questions: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired,
};

export default translate()(QuestionList);


// WEBPACK FOOTER //
// ./src/features/account-management/components/messages/QuestionList.js